module.exports = __webpack_public_path__ + "6c779fc3dc6a2d1457f38453df27af16.svg";